import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-voyage-arrow",
  "use": "icon-voyage-arrow-usage",
  "viewBox": "0 0 22 6",
  "content": "<symbol viewBox=\"0 0 22 6\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-voyage-arrow\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13 0.5V4.5H0V5.5H13H20H22L13 0.5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol